import {sendPush} from "../../marketing/gtm";

export const tawkChat = () => {
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/571f74d7a5e4d42103d2aa7a/default';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
    })();

    Tawk_API.onChatStarted = function(){
        sendPush({
            'event': 'web-vitals',
            'event_category': 'chat',
            'event_action': 'chat-first-interaction',
        })
    };
}
